// ----------------------------------------------------------------------

export function canAccessModule(user, perk) {
    // Staff users have access to all modules
    if (user?.is_staff_user) {
        return true;
    }
    const userPerk = user?.perks_on_user?.find(p => p.perk_name === perk);
    return userPerk?.can_access;
}
